import React, { ReactNode } from 'react';
import { Popover } from '@accolade/design-system-react';

import {
  TooltipHeader,
  TooltipBody,
  TooltipContent,
  ActionButton,
  CloseButton,
  TooltipIcon,
  TriggerText,
  Trigger,
  Button,
} from 'src/js/nextgen/plushcare-components/Tooltip/Tooltip.styled';

interface Props {
  triggerText?: string,
  contentHeader?: string,
  children: ReactNode,
  primaryButtonText?: string,
  primaryButtonHref?: string,
  closeButtonText?: string,
  id?: string,
}

export const Tooltip = ({
  triggerText,
  contentHeader,
  children,
  primaryButtonText,
  primaryButtonHref,
  closeButtonText,
  id = 'tooltip',
}: Props) => {
  const propIsDefined = (prop: boolean | string | Function | undefined) => !!prop;
  const displayTriggerText = propIsDefined(triggerText);
  const displayPrimaryButton = propIsDefined(primaryButtonText) && propIsDefined(primaryButtonHref);
  const displayCloseButton = propIsDefined(closeButtonText);
  const displayContentHeader = propIsDefined(contentHeader);

  return (
    <Popover>
      {displayTriggerText && (<TriggerText id={`${id}-trigger-text`}>{triggerText}</TriggerText>)}
      <Popover.Anchor
        onClick={(e) => { e.preventDefault(); }}
      >
        <Trigger asChild>
          <Button
            appearance="info"
            buttonType="text"
            id={`${id}-trigger-button`}
            data-testid={`${id}-trigger-button`}
            aria-label="tooltip-trigger"
          >
            <TooltipIcon id={`${id}-trigger-icon`} />
          </Button>
        </Trigger>
      </Popover.Anchor>
      <TooltipContent>
        <Popover.Arrow offset={4} />
        {displayContentHeader && <TooltipHeader id={`${id}-trigger-header`}>{contentHeader}</TooltipHeader>}
        <TooltipBody id={`${id}-trigger-body`}>
          {children}
        </TooltipBody>
        {displayPrimaryButton && (
          <ActionButton
            href={primaryButtonHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            {primaryButtonText}
          </ActionButton>
        )}
        {displayCloseButton && (
          <Popover.Close asChild>
            <CloseButton>
              {closeButtonText}
            </CloseButton>
          </Popover.Close>
        )}
      </TooltipContent>
    </Popover>
  );
};
